export var styles = {
  'fill': 'fill',
  'fillOpacity': 'fill-opacity',
  'stroke': 'stroke',
  'strokeOpacity': 'stroke-opacity',
  'strokeWidth': 'stroke-width',
  'strokeCap': 'stroke-linecap',
  'strokeJoin': 'stroke-linejoin',
  'strokeDash': 'stroke-dasharray',
  'strokeDashOffset': 'stroke-dashoffset',
  'strokeMiterLimit': 'stroke-miterlimit',
  'opacity': 'opacity',
  'blend': 'mix-blend-mode'
};